// Checkbox — thin styled wrapper around Base UI's headless Checkbox.
// Controlled: pass `checked` (+ optional `indeterminate`) and `onCheckedChange(next)`.
import React from 'react';
import { Checkbox as BaseCheckbox } from '@base-ui/react/checkbox';

export const Checkbox = ({ checked = false, indeterminate = false, onCheckedChange, disabled = false, size = 16, title }) => (
  <BaseCheckbox.Root
    checked={checked}
    indeterminate={indeterminate}
    onCheckedChange={(next) => onCheckedChange && onCheckedChange(next)}
    disabled={disabled}
    title={title}
    style={{
      width: size,
      height: size,
      flexShrink: 0,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 4,
      border: `1px solid ${checked || indeterminate ? 'var(--accent, #f5a524)' : 'var(--line-2)'}`,
      background: checked || indeterminate ? 'var(--accent, #f5a524)' : 'var(--bg-1)',
      color: '#0b0b0b',
      cursor: disabled ? 'not-allowed' : 'pointer',
      opacity: disabled ? 0.4 : 1,
      padding: 0,
      transition: 'background .1s, border-color .1s',
    }}
  >
    <BaseCheckbox.Indicator style={{ display: 'inline-flex' }}>
      {indeterminate ? (
        <svg width={size - 6} height={size - 6} viewBox="0 0 16 16">
          <path d="M3 8h10" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
        </svg>
      ) : (
        <svg width={size - 6} height={size - 6} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 8.5l3 3 7-7" />
        </svg>
      )}
    </BaseCheckbox.Indicator>
  </BaseCheckbox.Root>
);
